/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_TitleInputs */

const zh_linked_title = /** @type {(inputs: Linked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已绑定身份`)
};

const en_linked_title = /** @type {(inputs: Linked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked Identities`)
};

const es_linked_title = /** @type {(inputs: Linked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identidades vinculadas`)
};

/**
* | output |
* | --- |
* | "Linked Identities" |
*
* @param {Linked_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const linked_title = /** @type {((inputs?: Linked_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linked_title(inputs)
	if (locale === "en") return en_linked_title(inputs)
	return es_linked_title(inputs)
});